var defaultAttributes = "\nattribute vec3 aVertexPosition;\nattribute vec2 aTextureCoord;\n";
export default defaultAttributes.replace(/\n/g, '');